import React from 'react';

interface KeyIconProps {
  className?: string;
}

const KeyIcon: React.FC<KeyIconProps> = ({ className = 'w-5 h-5' }) => (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="currentColor" className={className}>

<path d="M272 240C272 169.3 329.3 112 400 112C470.7 112 528 169.3 528 240C528 310.7 470.7 368 400 368C389.6 368 379.5 366.8 369.9 364.4C361.8 362.4 353.2 364.9 347.3 370.8L318.1 400L264 400C250.7 400 240 410.7 240 424L240 464L200 464C186.7 464 176 474.7 176 488L176 528L112 528L112 449.9L269.2 292.7C275.1 286.8 277.5 278.2 275.6 270.1C273.3 260.5 272 250.4 272 240zM400 64C302.8 64 224 142.8 224 240C224 249.5 224.7 258.8 226.2 267.9L71 423C66.5 427.5 64 433.6 64 440L64 552C64 565.3 74.7 576 88 576L200 576C213.3 576 224 565.3 224 552L224 512L264 512C277.3 512 288 501.3 288 488L288 448L328 448C334.4 448 340.5 445.5 345 441L372.2 413.8C381.3 415.2 390.6 416 400.1 416C497.3 416 576.1 337.2 576.1 240C576.1 142.8 497.2 64 400 64zM432 240C449.7 240 464 225.7 464 208C464 190.3 449.7 176 432 176C414.3 176 400 190.3 400 208C400 225.7 414.3 240 432 240z"/></svg>
);

export default KeyIcon;


